const Footer = () => (
  <div className="c-footer">
    <p className="c-footer--signature"><a href="https://github.com/reeceaw">@reeceaw</a></p>
  </div>
);

export default Footer;
